import React from 'react';
import styles from './SoloStatusWide.module.css';
import { usePuzzleState } from '../../context/PuzzleStateContext';
import { getValue } from '../../utils/getValue';
import { useMetadata } from '../../context/MetadataContext'; 
import { useGlobalError } from '../../context/GlobalErrorContext';
import { useClock } from '../../hooks/useClock';

const SoloStatusWide = () => {
  const { puzzleState } = usePuzzleState();
  const { getText } = useMetadata();
  const { triggerError } = useGlobalError();

  // Format time function
  const formatTime = (seconds) => {
    const totalSeconds = Math.floor(seconds);
    
    // Calculate hours, minutes, and seconds
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const remainingSeconds = totalSeconds % 60;
    
    // Format the time string
    if (hours > 0) {
      return `${hours}:${minutes < 10 ? '0' : ''}${minutes}:${remainingSeconds < 10 ? '0' : ''}${remainingSeconds}`;
    } else {
      return `${minutes}:${remainingSeconds < 10 ? '0' : ''}${remainingSeconds}`;
    }
  };

  const clockTime = useClock(puzzleState?.state?.clock_time);

  // Don't render if no puzzle state
  if (!puzzleState) {
    triggerError({
      type: 'non-critical',
      message: 'SoloStatusWide component rendered without puzzle data. This indicates a routing/status determination error.'
    });
    return null;
  }

  return (
    <div className={styles.statusPanel}>
      <div className={styles.statusItem}>
        <span className={styles.label}>{getText('common_text.clock_time')}</span>
        <span className={styles.value}>{formatTime(clockTime)}</span>
      </div>
      <div className={styles.statusItem}>
        <span className={styles.label}>{getText('common_text.moves')}</span>
        <span className={styles.value}>{getValue(puzzleState,'state.move_count')}</span>
      </div>
      <div className={styles.statusItem}>
        <span className={styles.label}>{getText('common_text.hints')}</span>
        <span className={styles.value}>{getValue(puzzleState,'state.hint_count')}</span>
      </div>
    </div>
  );
};

export default SoloStatusWide;